export const FLAG_GETTING_ROUTES = 'FLAG_GETTING_ROUTES';
export const GET_ROUTES = 'GET_ROUTES';
export const CLEAR_ROUTES = 'CLEAR_ROUTES';
export const FLAG_ROUTE_ACTIVITY = 'FLAG_ROUTE_ACTIVITY';
export const GET_ROUTE = 'GET_ROUTE';
export const CLEAR_ROUTE = 'CLEAR_ROUTE';
